import { render, staticRenderFns } from "./Consortium.vue?vue&type=template&id=e106acb6&scoped=true"
import script from "./Consortium.vue?vue&type=script&lang=js"
export * from "./Consortium.vue?vue&type=script&lang=js"
import style0 from "./Consortium.vue?vue&type=style&index=0&id=e106acb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e106acb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e106acb6')) {
      api.createRecord('e106acb6', component.options)
    } else {
      api.reload('e106acb6', component.options)
    }
    module.hot.accept("./Consortium.vue?vue&type=template&id=e106acb6&scoped=true", function () {
      api.rerender('e106acb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Consortium/Consortium.vue"
export default component.exports